/* script */
//
//
//
//
//
//

// Components
import QuickLinksDisplay from 'shared/ui/components/analytics/QuickLinksDisplay.vue';

// Constants
const SUPPORTED_MODULES = {
    'future': [
        'participants',
        'sessions',
        'registration'
    ],
    'present': [
        'participants',
        'sessions',
        'live-streams'
    ],
    'past': [
        'participants',
        'sessions',
        'pkg-forms'
    ]
};

const __vue_script__ = {
    name: 'QuickLinks',

    components: { QuickLinksDisplay },

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            actions: [],
            enabled: false,
            eventStatus: this.$utils.workspaces.workspaceState(this.event)
        };
    },

    created() {
        try {
            const modules = [];
            for (const mod of SUPPORTED_MODULES[this.eventStatus]) {
                const installedModule = this.$services.blueprint.getModuleByName(mod);
                if (!installedModule) {
                    continue;
                }

                modules.push({
                    title: this.getModuleTitle(installedModule),
                    route: this.$utils.blueprint.getLinkForModule(installedModule, { eventId: this.event._id })
                });
            }

            this.actions = modules;
            this.enabled = this.actions.length !== 0;
        } catch (error) {
            console.error('[QuickLinks] Could not load modules', error.message);
        }
    },

    methods: {
        /**
         * Given a module this method returns the proper label
         *
         * @param {object} mod the module
         *
         * @returns {string} the module title
         */
        getModuleTitle(mod) {
            if (mod.label && this.$te(mod.label)) {
                return this.$t(mod.label);
            }

            if (mod.title) {
                return mod.title;
            }

            return this.$utils.strings.humanize(mod.name, true);
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c("quick-links-display", [
        _c(
          "ul",
          _vm._l(_vm.actions, function (action) {
            return _c("li", [
              _c("a", { attrs: { href: action.route } }, [
                _vm._v(_vm._s(action.title)),
              ]),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/analytics/QuickLinks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__